'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (css) {
  return css.replace(/\n/g, '').replace(/\s\s+/g, ' ');
};


//////////////////
// WEBPACK FOOTER
// ./~/minify-css-string/dist/index.js
// module id = 909
// module chunks = 0